export default __webpack_public_path__ + "static/media/ic-stop-watch.df88cf72.svg";